export default {
  title: 'Documents'
}
